import React from 'react'
import { useTransition, animated } from 'react-spring'

import { useQuizContext } from 'store/QuizStore'
import { FluidBox, FlexBox } from 'styled'

import ThemeIcon from 'components/ThemeIcon'

import {
  Root,
  Header,
  Lead,
  Icon,
  Body,
  ContentWrapper,
  TransitionWrapper,
} from './QuestionPanel.styled.js'

import DonutQuestion from './DonutQuestion'
import BarQuestion from './BarQuestion'
import ListQuestion from './ListQuestion'
// import DrawQuestion from './DrawQuestion'
import PieQuestion from './PieQuestion'
import ChartQuestion from './ChartQuestion'

const questionTypes = {
  donut: props => <DonutQuestion {...props}></DonutQuestion>,
  list: props => <ListQuestion {...props}></ListQuestion>,
  bar: props => <BarQuestion {...props}></BarQuestion>,
  // draw: props => <DrawQuestion {...props}></DrawQuestion>,
  chart: props => <ChartQuestion {...props}></ChartQuestion>,
  pie: props => <PieQuestion {...props}></PieQuestion>,
}

const AnimatedWrapper = animated(({ item, numQuestions, transitionState, navDirection }) => {
  const leaving = transitionState > 1.1
  const entering = transitionState < 0.9

  return (
    <TransitionWrapper>
      <Header entering={entering} leaving={leaving}>
        <Lead
          fs="textSmall"
          color="primary"
          justify="space-between"
          mb="spaceSmall"
          pb="spaceSmall"
        >
          <FlexBox fw="bold" align="center">
            <Icon entering={entering}>
              <ThemeIcon theme={item.theme}></ThemeIcon>
            </Icon>
            {item.questionName}
          </FlexBox>
          <FluidBox>
            {item.questionId} of {numQuestions}
          </FluidBox>
        </Lead>
        <FluidBox fs="textMedium" color="primary" lh={1.33} className="QuestionText">
          {item.questionText}
        </FluidBox>
      </Header>
      <Body>
        <div className="Inner">
          {questionTypes[item.questionType]({ ...item, entering, leaving, navDirection })}
        </div>
      </Body>
    </TransitionWrapper>
  )
})

const QuestionPanel = () => {
  const {
    selectedQuestion,
    navDirection,
    numQuestions,
    answers,
    currentQuestion,
    currentAnswer,
    isVisited,
  } = useQuizContext()

  currentQuestion.answer = currentAnswer
  currentQuestion.visited = isVisited

  const questionTransition = useTransition(currentQuestion, `${selectedQuestion}`, {
    initial: { state: 0.8 },
    from: { state: 0 },
    enter: { state: 1 },
    leave: {
      state: 2,
    },
    config: {
      duration: 1000,
    },
  })

  return (
    <Root>
      {answers ? (
        <ContentWrapper>
          <div className="Inner">
            {questionTransition.map(({ item, key, props }) => (
              <AnimatedWrapper
                key={key}
                item={item}
                transitionState={props.state}
                numQuestions={numQuestions}
                navDirection={navDirection}
              ></AnimatedWrapper>
            ))}
          </div>
        </ContentWrapper>
      ) : (
        ''
      )}
    </Root>
  )
}

export default QuestionPanel
